import { mount } from "svelte";
import IntegrationSettingsModal from "../modals/IntegrationSettingsModal/IntegrationSettingsModal.svelte";
import { activeProviderModalStore } from "../modals/IntegrationSettingsModal/stores";

export const bindIntegrationSettingsModal = () => {
  const target = document.getElementById("integration-settings-modal");

  // Use mount instead of directly creating a component instance
  const component = mount(IntegrationSettingsModal, {
    target,
  });

  // Return a function to open the modal with specific provider info
  return Object.assign(
    ({ provider, title, type }) => {
      activeProviderModalStore.set({ provider, title, type });
    },
    { component },
  );
};
